<div class="pure-g m-t-16" style="align-items: center">
  <div
    class="pure-g pure-u-md-18-24 pure-u-lg-19-24 pure-u-xl-20-24"
    style="overflow: auto; text-wrap: nowrap; display: flex; align-items: center">
    @if (selectedRows.length == 0) {
      <ng-container>
        <div style="width: 90px; display: inline-block; font-size: 0.9rem">Quick Filters:</div>
        @for (option of untaggedStatusList; track option.generatedCode) {
          @if ($index < numberOfQuickFiltersToShow) {
            <mc-button
              [attr.data-cy]="option.description"
              class="m-r-8 tag-button"
              [label]="option.description"
              variant="filled"
              appearance="neutral"
              fit="small"
              padding="compact"
              (click)="selectStatusFromQuickFilter(option)"></mc-button>
          } @else {
            @if ($index === numberOfQuickFiltersToShow) {
              <mc-popover style="position: relative" trigger="click" position="bottom-left">
                <div slot="trigger" class="overflow-count">+{{ untaggedStatusList.length - numberOfQuickFiltersToShow }}</div>
                <div class="tag-button-container">
                  @for (option of untaggedStatusList.slice(numberOfQuickFiltersToShow); track option.generatedCode) {
                    <mc-button
                      [attr.data-cy]="option.description"
                      class="m-r-8 tag-button"
                      [label]="option.description"
                      variant="filled"
                      appearance="neutral"
                      fit="small"
                      padding="compact"
                      (click)="selectStatusFromQuickFilter(option)"></mc-button>
                  }
                </div>
              </mc-popover>
            }
          }
        }
      </ng-container>
    }
  </div>
</div>
<div class="m-t-8 quick-filter-box pure-g">
  <div class="applied-filter-holder pure-u-md-20-24 pure-u-lg-20-24">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>

      @if (isArrayType(taggedFilter.value)) {
        @if (taggedFilter.key == 'WO Number' && getTaggedWorkOrderNumbers()) {
          <app-tag-with-overflow
            [data]="getTaggedWorkOrderNumbers()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectWorkorderNumber()"></app-tag-with-overflow>
        }

        @if (taggedFilter.key == 'Equipment Id' && getTaggedEquipmentNumbers()) {
          <app-tag-with-overflow
            [data]="getTaggedEquipmentNumbers()"
            [overflowCount]="2"
            [withaction]="true"
            [dismiss]="unselectEquipmentNumber()"></app-tag-with-overflow>
        } @else if (taggedFilter.key == 'Region' && getTaggedRegions()) {
          @for (taggedRegions of getTaggedRegions(); track taggedRegions) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedRegions().indexOf(taggedRegions))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedRegions().indexOf(taggedRegions)) }}</mc-tag
            >
          }

        } @else if (taggedFilter.key == 'Cluster' && getTaggedClusters()) {
          @for (taggedClusters of getTaggedClusters(); track taggedClusters) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedClusters().indexOf(taggedClusters))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedClusters().indexOf(taggedClusters)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Shop Country' && getTaggedShopCountries()) {
          @for (taggedCountries of getTaggedShopCountries(); track taggedCountries) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedShopCountries().indexOf(taggedCountries))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedShopCountries().indexOf(taggedCountries)) }}</mc-tag
            >
          }

        } @else if (taggedFilter.key == 'Shop ID' && getTaggedShopID()) {
          @for (taggedShops of getTaggedShopID(); track taggedShops) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedShopID().indexOf(taggedShops))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedShopID().indexOf(taggedShops)) }}</mc-tag
            >
          }

        } @else if (taggedFilter.key == 'Status' && getTaggedStatuses()) {
          @for (taggedStatus of getTaggedStatuses(); track taggedStatus.generatedCode) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedStatuses().indexOf(taggedStatus))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedStatuses().indexOf(taggedStatus)) }}</mc-tag
            >
          }
        } @else if (taggedFilter.key == 'Mode' && getTaggedModes()) {
          @for (taggedModes of getTaggedModes(); track taggedModes.repairMode) {
            <mc-tag
              class="m-r-4 extra-height"
              appearance="neutral-inverse"
              fit="small"
              withaction
              (click)="unselectSpecificFilter(taggedFilter, getTaggedModes().indexOf(taggedModes))"
              >{{ getTaggedFilterValue(taggedFilter, getTaggedModes().indexOf(taggedModes)) }}</mc-tag
            >
          }
        }
      } @else {
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
        >
      }
    }
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button class="clear-btn" variant="plain" appearance="primary" fit="small" padding="default" (click)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>
  <div class="utility-buttons pure-u-md-4-24 pure-u-lg-4-24">
    <div>
      <mc-button
        class="utility-button download"
        label="Button "
        variant="filled"
        appearance="neutral"
        fit="medium"
        icon="tray-arrow-down"
        [loading]="isDownload"
        hiddenlabel
        padding="default"
        (click)="onDownload()">
      </mc-button>
    </div>
    <div>
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
        <mc-button
          class="utility-button"
          slot="trigger"
          label="Button"
          icon="arrow-clockwise"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          padding="default"
          fit="medium"
          (click)="onRefresh()">
        </mc-button>
        <span>Refresh</span>
      </mc-tooltip>
    </div>
    <div class="pure-g">
      <mc-tooltip appearance="neutral-default" fit="small" position="bottom-center">
        <mc-button
          class="utility-button"
          slot="trigger"
          label="Button"
          icon="sliders-horizontal"
          variant="filled"
          appearance="neutral"
          hiddenlabel
          padding="default"
          fit="medium"
          (click)="showAdvanceFiltersModal()">
        </mc-button>
        <span>Filters</span>
      </mc-tooltip>

      <mc-modal
        (opened)="advancedFilterHasOpened()"
        [open]="showAdvanceFilters"
        (closed)="closeAdvanceFiltersModal()"
        heading="Filters"
        fit="small"
        dimension="large">
        <app-approval-all-advance-filter
          [isWorkOrderList]="isWorkOrderList"
          [workOrderFilterForm]="filterFormGroup.controls.workOrderFilterForm"></app-approval-all-advance-filter>
      </mc-modal>
    </div>
  </div>
</div>
